import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import {
  getCourseLearningActions,
  markLessonCompletedActions,
} from "../slices";
import { SECTION_ITEM_TYPE } from "@constants";

function* markLessonCompletedWorker({ payload }) {
  yield put(markLessonCompletedActions.pending());
  yield put(
    getCourseLearningActions.updateCompleteStatus({
      ...payload,
      isCompleted: true,
    })
  );

  try {
    let response;
    switch (payload.type) {
      case SECTION_ITEM_TYPE.LECTURE: {
        response = yield call(courseAPI.markLessonCompleted, payload.id);
        break;
      }
      case SECTION_ITEM_TYPE.QUIZ: {
        response = yield call(courseAPI.markQuizCompleted, payload.id);
        break;
      }
      case SECTION_ITEM_TYPE.ASSIGNMENT: {
        response = yield call(courseAPI.markAssignmentCompleted, payload.id);
        break;
      }
      default:
        break;
    }
    yield put(
      markLessonCompletedActions.success({ response, type: payload.type })
    );

    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(markLessonCompletedActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { markLessonCompletedWorker };
